/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Preferedthirdsubject2Inputs */

const de__field_preferedthirdsubject2 = /** @type {(inputs: _Field_Preferedthirdsubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Drittfach`)
};

/**

* @param {_Field_Preferedthirdsubject2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_preferedthirdsubject2 = /** @type {((inputs?: _Field_Preferedthirdsubject2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Preferedthirdsubject2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_preferedthirdsubject2(inputs)
});
export { _field_preferedthirdsubject2 as "_field_preferedThirdSubject" }